import DixaIcon from '@dixa/dixa-modern-icons';
import { Tooltip } from '@dixa/lib-shared-habla';
import { boundMethod } from 'autobind-decorator';
import classnames from 'classnames';
import { MetaConversation } from 'lib-shared-legacy-types';
import { Component } from 'react';

import { ConversationListItem } from './conversationListItem';
import styles from './conversations.module.scss';
import { SidebarMenuProps } from './sidebarMenu';

type PropsT = SidebarMenuProps;

type StateT = {
  showAllConversations: boolean;
};

export class Conversations extends Component<PropsT, StateT> {
  constructor(props: PropsT) {
    super(props);

    this.state = {
      showAllConversations: false,
    };

    this.toggleConversationShow = this.toggleConversationShow.bind(this);
  }

  toggleConversationShow() {
    this.setState({ showAllConversations: !this.state.showAllConversations });
  }

  @boundMethod
  renderListItems(currentMetaConv: MetaConversation, listIndex: number) {
    const {
      typings,
      conversationsRemove,
      typingRemove,
      wsRequest,
      isMenuOpen,
      conversationsLastSearchParams,
      onToggleNavigation,
    } = this.props;

    if (!currentMetaConv) {
      return null;
    }
    const conversationTyping = typings.find(
      (typing) => typing.csid === currentMetaConv.conversation.id,
    );

    return (
      <ConversationListItem
        key={currentMetaConv.conversation.id as any}
        listIndex={listIndex}
        conversationsLastSearchParams={conversationsLastSearchParams}
        isMenuOpen={isMenuOpen}
        isViewingConversation={
          window.location.pathname ===
          `${BASEPATH}conversation/${currentMetaConv.conversation.id}`
        }
        conversationsRemove={conversationsRemove}
        typingRemove={typingRemove}
        wsRequest={wsRequest}
        typing={conversationTyping}
        metaConversation={currentMetaConv}
        onToggleNavigation={onToggleNavigation}
      />
    );
  }

  renderShowMoreOrLess() {
    const { metaConversationsAfterBreak, isMenuOpen } = this.props;
    const { showAllConversations } = this.state;
    if (isMenuOpen) {
      return showAllConversations ? (
        <span>Show less</span>
      ) : (
        <span>Show more ({metaConversationsAfterBreak.length})</span>
      );
    }
    return (
      <DixaIcon
        icon={showAllConversations ? 'minus' : 'dots'}
        className={styles.showMoreOrLessIcon}
      />
    );
  }

  render() {
    const {
      metaConversationsBeforeBreak,
      metaConversationsAfterBreak,
      isMenuOpen,
    } = this.props;
    const { showAllConversations } = this.state;
    const renderedConversations = showAllConversations
      ? metaConversationsBeforeBreak.concat(metaConversationsAfterBreak)
      : metaConversationsBeforeBreak;

    const rootClass = classnames({
      [styles.root]: true,
      [styles.rootCollapsed]: !isMenuOpen,
    });
    return (
      <ul className={rootClass}>
        {renderedConversations.map((metaConversation, index) =>
          this.renderListItems(metaConversation, index),
        )}

        {metaConversationsAfterBreak.length > 0 && (
          <li className={styles.listItem}>
            <Tooltip
              content={showAllConversations ? 'Show less' : 'Show more'}
              disabled={isMenuOpen}
            >
              <button
                onClick={this.toggleConversationShow}
                className={styles.showMoreOrLess}
              >
                {this.renderShowMoreOrLess()}
              </button>
            </Tooltip>
          </li>
        )}
      </ul>
    );
  }
}
